const SESSION_TIMEOUT_QUERY_PARAM_KEY = 'isSessionTimeout';
export default SESSION_TIMEOUT_QUERY_PARAM_KEY;
